import { Field, useFormikContext } from 'formik';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { ListQuery } from '../../models/ListQuery';
import { getBuildingNamesWithPagination } from '../../services/buildingService';
import { getFloorsNamesWithPagination } from '../../services/floorService';
import { IAppState } from '../../store/types';
import { appendFilter } from '../../utilities/filters';
import Label from '../label/label';
import PaginatedSearchableSelectField from '../selection-field/paginated-searchable-select-field';

export const MasterControllerDetails: FC = () => {
    const { values, setFieldValue } = useFormikContext<any>();
    const { translate } = useLocale()
    const siteId = useSelector((state: IAppState) => state.site.site.value)

    return <div>
        <div className="flex flex-row">
            <div className="flex flex-col flex-1 pr-3">
                <Label htmlFor='type'
                    className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.type)}:</Label>
                <Field
                    name="type"
                    type="text"
                    disabled={true}
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />
            </div>

            <div className="flex flex-col flex-1 pr-3">
                <Label htmlFor='site'
                    className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.site)}:</Label>
                <Field
                    name="site"
                    type="text"
                    disabled={true}
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />
            </div>
        </div>
        <div className="flex flex-row flex-1 pt-2 ">
            <div className="flex flex-col flex-1 pr-3">
                <Label htmlFor='buildingId'
                    className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.building)}:</Label>
                <PaginatedSearchableSelectField
                    name={translate.byKey(TranslationKeys.building)}
                    key={"buildingId"}
                    accessor='buildingId'
                    dataMethod={(listParameters?: ListQuery) => getBuildingNamesWithPagination({ ...listParameters, filters: appendFilter(values.siteId ?? siteId, 'Site id', 'site.id', listParameters?.filters ?? []) })}
                    searchAccessor={'buildingName'}
                    onSelect={(event, item) => {
                        setFieldValue('buildingName', item?.label);
                        setFieldValue('buildingId', item?.value);
                    }}
                    selectedItemLabel={values.buildingName}
                    onDelete={(event) => {
                        setFieldValue('buildingId', undefined);
                        setFieldValue('floorId', undefined);
                        setFieldValue('buildingName', undefined);
                    }} />
            </div>
            <div className="flex flex-col flex-1 pr-3">
                <Label htmlFor='floorId'
                    className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.floor)}:</Label>
                <PaginatedSearchableSelectField
                    name={translate.byKey(TranslationKeys.floor)}
                    key={"floorId"}
                    accessor='floorId'
                    dataMethod={getFloorsNamesWithPagination}
                    searchAccessor={'floorName'}
                    onSelect={(event, item) => {
                        setFieldValue('floorName', item?.label);
                        setFieldValue('floorId', item?.value);
                    }}
                    selectedItemLabel={values.floorName}
                    onDelete={(event) => {
                        setFieldValue('floorId', undefined);
                        setFieldValue('floorName', undefined);
                    }}
                    dependent={{ accessor: 'buildingId', name: 'Building', key: 'building.id', value: values.buildingId, childAcceccor: 'floorId' }}
                    disabled={!!!values.buildingId}/>
            </div>
        </div>
        <div className="flex flex-row pt-2">
            <div className="flex flex-col flex-1 pr-3">
                <Label htmlFor='heartBeatReporting'
                    className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.diagnosticReportingTime)}:</Label>
                <Field
                    name="heartBeatReporting"
                    type="number"
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm bg-gray-input w-full" />
            </div>
            <div className="flex flex-col flex-1 pr-3">
                <Label htmlFor='version'
                    className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.version)}:</Label>
                <Field
                    name="version"
                    disabled={true}
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />
            </div>
        </div>
    </div>;
};
